// extracted by extract-css-chunks-webpack-plugin
module.exports = {"deleteButton":"deleteButton_hkW_Q"};